let Keyboard = require("../lib/Keyboard");

let drops = [];

document.addEventListener("click", function (evt) {
  drops.forEach(function (drop) {
    if (evt && ReactDOM.findDOMNode(drop).contains(evt.target)) {
      return;
    }

    drop.close(false);
  });
});

class Drop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false,
      index: this.getDefaultIndex()
    };
  }

  getDefaultIndex() {
    return /search|text/.test(this.props.children[0].props.type) ? 0 : -1;
  }

  componentDidMount() {
    drops.push(this);
    this.refs.target.firstElementChild.tabIndex = "0";
  }

  componentWillUnmount() {
    drops = drops.filter(function (drop) {
      return this !== drop;
    }, this);
  }

  componentDidUpdate(prevProps, prevState) {
    let items;
    let index = this.state.index;

    if (this.state.opened) {
      if (index > -1) {
        items = ReactDOM.findDOMNode(this).querySelectorAll(this.props.selector);
        if (items.length) {
          items[index].focus();
        }
      }
    }

    if (this.state.opened !== prevState.opened) {
      this.props.onToggle(this.state.opened);
    }
  }

  _toggle(evt) {
    if (this.state.opened) {
      this.close();
    }
    else {
      this._open();
    }
  }

  _onClickToggle(evt) {
    if (this.props.autoToggle) {
      this._toggle();
    }
  }

  _onKeyToggle(evt) {
    if (this.props.autoToggle && Keyboard.isEnter(evt)) {
      this._toggle();
    }
  }

  _onFocusReveal(evt) {
    let items = ReactDOM.findDOMNode(this).querySelectorAll(this.props.selector);
    let index = [].indexOf.call(items, evt.target);
    let a = evt.target.nodeName;
    let b = evt.target.parentNode.nodeName;
    let targets = ["A", "BUTTON"];

    if (this.props.autoClose && evt.type === "click" && (targets.includes(a) || targets.includes(b))) {
      this.close(false);
      return;
    }

    this.setState({ index });
  }

  _onKeyDown(evt) {
    let items;
    let index;

    if (Keyboard.isTab(evt)) {
      this.close();
    }
    else if (this.state.opened && Keyboard.isUpOrDownArrow(evt)) {
      evt.preventDefault();

      items = ReactDOM.findDOMNode(this).querySelectorAll(this.props.selector);
      index = this.state.index;

      index += Keyboard.isDownArrow(evt) ? 1 : -1;
      index = (items.length + Math.max(-1, index)) % items.length;

      this.setState({ index });
    }
  }

  _onKeyUp(evt) {
    if (Keyboard.isEscape(evt)) {
      if (this.state.opened) {
        evt.stopPropagation();
      }
      this.close();
    }
  }

  _open() {
    if (!this.state.opened) {
      document.body.style.overflowX = "hidden";

      this.setState({
        opened: true,
        index: this.getDefaultIndex()
      });
    }
  }

  // public
  close(_focus) {
    if (this.state.opened) {
      document.body.style.overflowX = "auto";

      this.setState({
        opened: false,
        index: this.getDefaultIndex()
      });

      if (_focus !== false) {
        this.refs.target.firstElementChild.focus();
      }
    }
  }

  // public. open or close, but do not reset tab index
  reveal(opened) {
    this.setState({ opened });
  }

  render() {
    return (
      <div className="mc-drop" data-align={this.props.align} onKeyDown={(e) => this._onKeyDown(e)} onKeyUp={(e) => this._onKeyUp(e)}>
        <div ref="target" className="mc-drop-target" onClick={(e) => this._onClickToggle(e)} onKeyDown={(e) => this._onKeyToggle(e)}>
          {this.props.children[0]}
        </div>
        <div ref="reveal" className="mc-drop-reveal" aria-hidden={!this.state.opened} onFocus={(e) => this._onFocusReveal(e)} onClick={(e) => this._onFocusReveal(e)}>
          {this.props.children[1]}
        </div>
      </div>
    );
  }
}

Drop.defaultProps = {
  selector: "a, button, input, textarea",
  autoToggle: true,
  autoClose: false,
  align: "left",
  onToggle: function (opened) {}
};

module.exports = Drop;
